module.exports = __webpack_public_path__ + "static/knotheadbands-223f4eab1e2677c968df22241636666f.jpeg";